import React from 'react';
import { FormControlLabel, Checkbox, Link, Box } from '@mui/material';

const PrivacyConsent = ({ checked, onChange }) => {
  return (
    <Box sx={{ mb: 2 }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={onChange}
            sx={{
              color: '#f94c57',
              '&.Mui-checked': {
                color: '#f94c57',
              },
            }}
          />
        }
        label={
          <span>
            I agree to the{' '}
            <Link
              href="https://www.pablothiermann.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: '#f94c57',
                textDecoration: 'underline',
                '&:hover': {
                  color: '#d32f2f',
                },
              }}
            >
              Privacy Policy
            </Link>
          </span>
        }
      />
    </Box>
  );
};

export default PrivacyConsent; 